// extracted by mini-css-extract-plugin
export default {"Footer__wrap":"Footer_Footer__wrap__E1e35","Footer":"Footer_Footer__WiYT0","Footer__element":"Footer_Footer__element__vfHUz"};